/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Link } from 'foundations-components/transitional/components/Link';
import { Select } from 'foundations-components/transitional/components/Select';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { LinkTypes } from '../../constants/link';
import { getHowToCreateAnchorUrl } from '../../utils/anchor';
import { alphabeticalSort } from '../../utils/link';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class AnchorLinkField extends PureComponent {
  constructor(props) {
    super(props);
    this.handleChange = ({
      target: {
        value: option
      }
    }) => {
      this.props.onChange({
        anchorName: option.value
      });
    };
    this.fetchAnchorLinks = (input, callback) => {
      if (!this.mounted) return;
      this.props.fetchAnchors(input).then(anchors => {
        const options = [];
        let searchable;
        if (anchors.length) {
          anchors.forEach(anchor => {
            options.push({
              text: anchor.id,
              value: anchor.id
            });
          });
          options.sort(alphabeticalSort);
          searchable = true;
        } else {
          if (input) {
            searchable = true;
          } else {
            options.push({
              text: I18n.text(`RichTextLib.links.linkTypes.${LinkTypes.ANCHOR}.noAnchorsTitle`),
              disabled: true,
              help: /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx(FormattedMessage, {
                  message: `RichTextLib.links.linkTypes.${LinkTypes.ANCHOR}.noAnchorsHelp`
                }), ' ', /*#__PURE__*/_jsx(Link, {
                  href: getHowToCreateAnchorUrl(),
                  external: true,
                  children: I18n.text(`RichTextLib.links.linkTypes.${LinkTypes.ANCHOR}.learnMore`)
                })]
              })
            });
            searchable = false;
          }
        }
        this.setState({
          searchable
        }, () => {
          callback(null, {
            options
          });
        });
      });
    };
    this.state = {
      searchable: true
    };
  }
  componentDidMount() {
    this.mounted = true;
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  render() {
    const {
      anchor
    } = this.props;
    return /*#__PURE__*/_jsx(FormControl, {
      label: I18n.text(`RichTextLib.links.linkTypes.${LinkTypes.ANCHOR}.label`),
      marginBlockStart: "0",
      children: /*#__PURE__*/_jsx(Select, {
        "data-test-id": "anchor-link-dropdown",
        searchable: this.state.searchable,
        value: anchor,
        loadOptions: this.fetchAnchorLinks,
        onSelectedOptionChange: this.handleChange,
        placeholder: I18n.text(`RichTextLib.links.linkTypes.${LinkTypes.ANCHOR}.placeholder`)
      })
    });
  }
}
AnchorLinkField.propTypes = {
  fetchAnchors: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  anchor: PropTypes.string
};